<template>
  <div>
    <pt-sub-title title="报告预约解读详情"></pt-sub-title>
    <table :class="$style['sign-notes-detail']">
      <pt-message-table-item label="姓名">
        {{data.name}}
      </pt-message-table-item>
      <pt-message-table-item label="手机号">
        {{data.phone}}
      </pt-message-table-item>
      <pt-message-table-item label="报告姓名">
        {{data.patientName}}
      </pt-message-table-item>
      <pt-message-table-item label="报告名称">
        {{data.reportName}}
      </pt-message-table-item>
      <pt-message-table-item label="样本条码号">
        {{data.sampleId}}
      </pt-message-table-item>
      <pt-message-table-item label="报名时间">
        {{notesDetail.registration_time}}
      </pt-message-table-item>
      <pt-message-table-item label="地区">
        {{notesDetail.area}}
      </pt-message-table-item>
      <pt-message-table-item label="已分配人员">
        {{notesDetail.allotUserName}}
      </pt-message-table-item>
       <pt-message-table-item label="状态">
        {{notesDetail.sign_status}}
      </pt-message-table-item>
    </table>
  </div>
</template>

<script>
export default {
  name: 'appointment-report-read',
  props: {
    notesDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    data () {
      return (this.notesDetail.genericFormData && this.notesDetail.genericFormData.data) || {}
    }
  }
}
</script>

<style module lang="less">
.sign-notes-detail{
   padding: 0 20px;
}
</style>
